import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import utc from 'dayjs/plugin/utc';
import { createRoot } from 'react-dom/client';

import { RootStoreProvider } from 'stores/global/RootStore/context';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/carousel/styles.css';
import 'styles/globalStyles.scss';

dayjs.extend(utc);

import './scripts';
import { App } from './app';
import { initSentry } from './scripts/initSentry';

initSentry();

createRoot(document.getElementById('root') as HTMLElement).render(
  <RootStoreProvider>
    <App />
  </RootStoreProvider>,
);
